import { useState, useEffect } from 'react';
import { api } from '../../../services/api';
import ClientAutocomplete from '../../../components/feature/ClientAutocomplete';

interface Client {
  id: string;
  nom: string;
  telephone: string;
  notes_mesures?: string;
}

interface FormulaireClientProps {
  nom: string;
  telephone: string;
  onNomChange: (v: string) => void;
  onTelChange: (v: string) => void;
  onClientSelect?: (clientId: string, notesMesures?: string) => void;
}

export default function FormulaireClient({ nom, telephone, onNomChange, onTelChange, onClientSelect }: FormulaireClientProps) {
  const [clients, setClients] = useState<Client[]>([]);

  useEffect(() => {
    const token = localStorage.getItem('atelier_bassoum_token');
    if (token) {
        api.getClients(token).then(data => {
            setClients(data.map((c: any) => ({
                id: String(c.id),
                nom: c.nom,
                telephone: c.telephone,
                notes_mesures: c.notes_mesures || ''
            })));
        }).catch(() => {});
    }
  }, []);

  const handleClientSelect = (n: string, id: string | null) => {
    onNomChange(n);
    if (id) {
       const c = clients.find(cl => String(cl.id) === id);
       if (c) {
          onTelChange(c.telephone || '');
       }
       if (onClientSelect) onClientSelect(id, c?.notes_mesures || '');
    } else {
       // Exact name match check
       const exactMatch = clients.find(cl => cl.nom.trim().toLowerCase() === n.trim().toLowerCase());
       if (exactMatch) {
          onTelChange(exactMatch.telephone || '');
          if (onClientSelect) onClientSelect(String(exactMatch.id), exactMatch.notes_mesures || '');
       } else {
          if (onClientSelect) onClientSelect('', '');
       }
    }
  };

  return (
    <div className="grid gap-4">
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
          Client (Rechercher ou Créer) <span className="text-red-500">*</span>
        </label>
        <ClientAutocomplete 
            clients={clients}
            value={nom}
            onChange={handleClientSelect}
            required={true}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
          Téléphone <span className="text-xs font-normal text-gray-400 ml-1">(Optionnel)</span>
        </label>
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
            <i className="ri-phone-line" />
          </div>
          <input
            type="tel"
            value={telephone}
            onChange={e => onTelChange(e.target.value)}
            placeholder="+223 7X XX XX XX"
            className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-foret-400 bg-gray-50 font-semibold"
          />
        </div>
      </div>
    </div>
  );
}
